import * as React from "react";
import {
    DrawerBody,
    DrawerHeader,
    DrawerHeaderTitle,
    Drawer,
    useRestoreFocusSource,
    useRestoreFocusTarget,
} from "@fluentui/react-components";

import { Dismiss24Regular, Microscope24Filled, Notepad20Filled } from "@fluentui/react-icons";

import { Divider } from "@fluentui/react-components";
import OiTree, { OiTreeRef } from "./OiTree";

interface AssetDrawerProps {
    className?: string;
    startOpen: boolean;


}

export interface OiDrawerRef {
    refreshReports: () => Promise<void>;
    open: () => void;
}

export default React.forwardRef<OiDrawerRef, AssetDrawerProps>(function AssetDrawer(props, ref) {
    const [isOpen, setIsOpen] = React.useState(false);
    const oiTreeRef = React.useRef<OiTreeRef>(null);



    React.useImperativeHandle(ref, () => ({
        refreshReports: async () => {
            await oiTreeRef.current?.refreshReports();
        },
        open: () => {
            setIsOpen(true);
        }
    }), []);

    const restoreFocusTargetAttributes = useRestoreFocusTarget();
    const restoreFocusSourceAttributes = useRestoreFocusSource();

    React.useEffect(() => { setIsOpen(props.startOpen) }, [props.startOpen]);

    return (
        <div className={`${props.className} h-8 z-20  fixed md:relative  `}>
            <div className="fixed h-screen">
                {!isOpen && (
                    <button className="h-screen w-6 bg-primary-light dark:bg-primary-dark hover:bg-opacity-75 "
                        {...restoreFocusTargetAttributes}
                        onClick={() => setIsOpen(true)}
                    >
                        <Notepad20Filled className="absolute top-2 left-0.5" />
                    </button>
                )}

                <Drawer
                    {...restoreFocusSourceAttributes}
                    type={window.innerWidth <= 768 ? "overlay" : "inline"}
                    separator
                    open={isOpen}
                    style={{ height: "100%" }}
                    onOpenChange={(_, { open }) => setIsOpen(open)}

                >
                    <DrawerHeader>
                        <DrawerHeaderTitle
                            action={

                                <button
                                    aria-label="Close"
                                    onClick={() => setIsOpen(false)}
                                >
                                    <Dismiss24Regular />
                                </button>
                            }
                        >

                            <div className="flex items-center gap-2">
                                <Microscope24Filled />
                                O&I
                            </div>
                        </DrawerHeaderTitle>
                        <Divider />
                    </DrawerHeader>

                    <DrawerBody className="relative p-0 overflow-hidden">
                        <OiTree
                        />

                    </DrawerBody>
                </Drawer>
            </div>
            <div className={isOpen ? "w-80" : "w-6"} />
        </div>

    );
});